import(/* webpackMode: "eager", webpackExports: ["PartnerTalentSearchScreen"] */ "/app/apps/platform-web/components/partner-app/screens/PartnerTalentSearchScreen.tsx");
